import * as React from 'react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { PortalSearchBar } from '../';
import { IAppOnlyStore } from './../../../stores/AllStores';
import { Button, EButtonType } from './../../action';
import { CustomerType, EUserTypeName } from './../../../../../common/interfaces/user';
import { AdminNavigationBar } from '../AdminNavigationBar';
import { InternalNavigationBar } from '../InternalNavigationBar';

// Styles
const s = require('./TopBar.css');
const dropdownIcon = require('./../../../assets/dropdown-arrow.svg');
const pacLogo = require('./../../../assets/pacific-auto-logo.png');
const pbiLogo = require('./../../../assets/pacific-best-logo.png');

// Props
interface ITopBarProps {
    onUserDropdownButtonClick: () => void;
    userDropdownIsOpen: boolean;
    userType: EUserTypeName;
    userEmail: string | null;
    customerIsPAC?: boolean;
    customerIsPBI?: boolean;
}

// Component
@observer
export class TopBar extends React.Component<ITopBarProps, {}> {
    static get defaultProps(): ITopBarProps {
        return {
            onUserDropdownButtonClick: null,
            userDropdownIsOpen: false,
            userType: EUserTypeName.Portal,
            userEmail: null,
            customerIsPAC: false,
            customerIsPBI: false
        };
    }

    constructor(props: any) {
        super(props);
    }

    @computed
    private get logoImage(): string | null {
        return this.props.customerIsPBI ? pbiLogo : pacLogo;
    }

    public render() {
        return (
            <div className={s.topbar}>
                <div className={s.left}>
                    {this.logoImage && <img className={s.logo} src={this.logoImage} width={90} height={60} alt="" />}
                </div>

                <div className={s.middle}>
                    {(this.props.userType === EUserTypeName.Portal && <PortalSearchBar />) ||
                        (this.props.userType === EUserTypeName.Admin && <AdminNavigationBar />) ||
                        (this.props.userType === EUserTypeName.Internal && <InternalNavigationBar />)}
                </div>

                <div className={s.right}>
                    <button
                        onClick={this.handleUserDropdownButtonClick}
                        className={classNames(s.myAccount, {
                            [s.active]: this.props.userDropdownIsOpen
                        })}
                    >
                        <p>
                            {this.props.userEmail && <span>{this.props.userEmail}</span>}
                            <strong>My account</strong>
                        </p>
                        <img
                            className={classNames(s.myAccountIcon, {
                                [s.active]: this.props.userDropdownIsOpen
                            })}
                            src={dropdownIcon}
                            width={11}
                            height={16}
                        />
                    </button>
                </div>
            </div>
        );
    }

    private handleUserDropdownButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (this.props.onUserDropdownButtonClick) {
            e.stopPropagation();
            this.props.onUserDropdownButtonClick();
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/TopBar/TopBar.tsx